import React, { useState, useEffect } from 'react'
import api from '../../components/api'

import { useSadtContext } from '../../context/SadtContext'


import { useTabelaGestao } from '../../context/GestaoPendenciasContext'



import { Link } from 'react-router-dom'
import { useEnunciadoContext } from '../../context/enunciadoContext'
import { useVerificaDesafioContext } from '../../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../../context/secaoEnunciadoContext'

import StatusValidacaoSecao from '../StatusValidacaoSecao'

import Table from 'react-bootstrap/Table'


const SADT = (props) => {


    var ano = props.ano
    var energia_id = props.energia_id

    const { atualizacaoGestao } = useTabelaGestao()


    const { energiaEquipamento_id, setEnergiaEquipamento_id } = useSadtContext()
    const [resultadoEquipamentos, setResultadoEquipamentos] = useState()
    
    const [informa, setInforma] = useState(true)


    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()




    const [questao1, setQuestao1] = useState()
    const [totalPendencias, setTotalPendencias] = useState(0)
    

    const consultaInforma = () => {

        api.get(`energiaInforma/${energia_id}/informaSADT`).then((result) => {

            //console.log(result.data)
            setInforma(result.data[0].informaSADT)

        }).catch((err) => {

            console.log(err.response)

        })
    }



    useEffect(() => {

        verificaValidacoes()

    }, [energia_id, verificaDesafio])


    const verificaValidacoes = () => {

        //console.log('verificado')

        setQuestao1()
        
        

        if (energia_id) {

            var dataPost = {

                formulario_id: energia_id,
                desafio: 'Energia',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                var data = result.data
                //console.log(data)
                var totalErros = 0

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case 'SADT':

                                totalErros = totalErros + 1
                                setQuestao1('red')
    
                            break

                        }

                    }

                    

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }



    const consultaEquipamentos = () => {

        //console.log('aqui')

        if (energia_id) {

            api.get(`energiaEquipamentoListaTodos/${energia_id}`).then((result) => {

                //console.log(result.data, '!!')
                setResultadoEquipamentos(result.data.map((rs) =>
                
                    <tr style={{ cursor: 'pointer'}} onClick={() => {window.$('#modalSADT').modal('show');setEnergiaEquipamento_id(rs.energiaEquipamento_id)}}>
                        <td>
                            {rs.equipamentoCategoria}
                        </td>
                        <td>
                            {rs.descricao}
                        </td>
                        <td>
                            {rs.anoFabricacao}
                        </td>
                        <td>
                            {rs.quantidade}
                        </td>
                    </tr>
                
                ))

            }).catch((err) => {

                console.log(err.response)

            })
        }

    }


    useEffect(() => {

        var dataPost = {

            tipo: 'informaSADT',
            informa: informa,

        }

        api.post(`energiaInforma/${energia_id}`, dataPost).then((result) => {

            console.log(result.data)

        }).catch((err) => {

            console.log(err.response)

        })

    }, [informa])


    useEffect(() => {

        consultaEquipamentos()
        consultaInforma()
        
        
    }, [ano, energia_id, atualizacaoGestao])




    return (
        <div>




            <div className="col-md-12">
                <div align="left">

                
                    <select className="form-control" value={informa} onChange={event => setInforma(event.target.value)}>
                        <option value={true}>A instituição possui o(s) equipamento(s) e reportará suas informações</option>
                        <option value={false}>A instituição não possui o(s) equipamento(s) ou a instituição possui o(s) equipamento(s) mas não reportará suas informações</option>
                    </select>
                    <br/>

                </div>
            </div>


            <div className="col-md-12" style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>
                <div align="left">

                    <Link to='#' style={{ color: questao1 }} onClick={() => {setEnunciado('SADT');setSecaoEnunciado('SADT');window.$('#modalValidacao').modal('show')}}>
                    [Informar Não Conformidade]</Link>
                    <br/><br/>
                    
                    <button type="button" className="btn btn-warning" onClick={() => {window.$('#modalSADT').modal('show');setEnergiaEquipamento_id()}}  >+ Adicionar Equipamento</button>
                    <br/><br/>

                </div>
            </div>


            <div className="col-md-12" style={{ display: informa == 'true' || informa == true || informa == null ? 'block' : 'none' }}>


                <Table striped bordered hover>

                    <thead>
                        
                        <tr>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Tipo

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Marca

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Entrada operação

                            </th>
                            <th style={{backgroundColor: '#e6f7ec'}}>

                                Saída operação

                            </th>
                           

                        </tr>
                    </thead>
                    <tbody>
                        {resultadoEquipamentos}
                    </tbody>

                </Table>

            </div>



            

            <StatusValidacaoSecao desafio="Energia" secaoCampo="secaoSADT" totalPendencias={totalPendencias} nomeDesafio="Desafio Energia" formulario_id={energia_id} secao="SADT" ano={ano} />


        </div>
    )


}

export default SADT